import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDangerIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			style: { mixBlendMode: "multiply" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3333 15H1.66667C0.911746 15 0.429057 14.1955 0.784314 13.5294L7.11765 1.65441C7.49412 0.948529 8.50588 0.948529 8.88235 1.65441L15.2157 13.5294C15.5709 14.1955 15.0883 15 14.3333 15Z",
			fill: "#D40B00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 5.5V9",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 11.5C8.09889 11.5 8.19556 11.5293 8.27779 11.5843C8.36001 11.6392 8.4241 11.7173 8.46194 11.8087C8.49978 11.9 8.50968 12.0006 8.49039 12.0975C8.4711 12.1945 8.42348 12.2836 8.35355 12.3536C8.28363 12.4235 8.19454 12.4711 8.09755 12.4904C8.00056 12.5097 7.90002 12.4998 7.80866 12.4619C7.7173 12.4241 7.63921 12.36 7.58427 12.2778C7.52932 12.1956 7.5 12.0989 7.5 12C7.5 11.8674 7.55268 11.7402 7.64645 11.6464C7.74021 11.5527 7.86739 11.5 8 11.5",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgDangerIcon);
export default ForwardRef;
